import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();

  // Mientras AuthContext verifica el token, no mostramos nada (pantalla en blanco o puedes poner un spinner)
  if (!ready) return null;

  // Si ya terminó de verificar y NO hay usuario, lo regresamos al login
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Si SÍ hay usuario, lo dejamos pasar a ver la página (children)
  return children;
}